import { jsx as t } from "react/jsx-runtime";
import { IconButton as i } from "@chakra-ui/react";
import { forwardRef as s, useMemo as u } from "react";
import { getIconSizeFromButtonSize as f } from "./helper.js";
import { Icon as p } from "../icon/icon.js";
const S = s(
  ({ icon: r, size: o = "md", variant: n = "secondary", ...m }, e) => {
    const c = u(() => f(o), [o]);
    return /* @__PURE__ */ t(
      i,
      {
        ref: e,
        isRound: !0,
        style: { aspectRatio: 1 },
        variant: n,
        size: o,
        icon: /* @__PURE__ */ t(p, { size: c, icon: r }),
        ...m
      }
    );
  }
);
export {
  S as IconButton
};
